###
  lektiondestages.blogspot.se/2013/01/calculate-catmull-rom-splines-using.html
###

module.exports = (points, divisions = 32) ->
  points = [].concat(points)
  spline = points.slice 0, 1

  while points.length > 3
    p1x = 1 * points[3].x - 3 * points[2].x + 3 * points[1].x - points[0].x
    p1y = 1 * points[3].y - 3 * points[2].y + 3 * points[1].y - points[0].y
    p2x = 2 * points[0].x - 5 * points[1].x + 4 * points[2].x - points[3].x
    p2y = 2 * points[0].y - 5 * points[1].y + 4 * points[2].y - points[3].y

    st1 = 1.0 / divisions
    st2 = st1 * st1
    st3 = st1 * st2

    d1x = 0.5 * (st3 * p1x + st2 * p2x + st1 * (points[2].x - points[0].x))
    d1y = 0.5 * (st3 * p1y + st2 * p2y + st1 * (points[2].y - points[0].y))
    d2x = 3.0 * st3 * p1x + st2 * p2x
    d2y = 3.0 * st3 * p1y + st2 * p2y
    d3x = 3.0 * st3 * p1x
    d3y = 3.0 * st3 * p1y

    px = points[1].x
    py = points[1].y

    for j in [0...divisions]
      px  += d1x
      py  += d1y
      d1x += d2x
      d1y += d2y
      d2x += d3x
      d2y += d3y

      spline.push x: px, y: py

    points.shift()

  return spline
